import React, { SetStateAction, useState } from "react";
import { Button, Input } from "antd";
import "./index.scss";

const dialerKeys = [
  { main: "1", sub: "" },
  { main: "2", sub: "ABC" },
  { main: "3", sub: "DEF" },
  { main: "4", sub: "GHI" },
  { main: "5", sub: "JKL" },
  { main: "6", sub: "MNO" },
  { main: "7", sub: "PQRS" },
  { main: "8", sub: "TUV" },
  { main: "9", sub: "WXYZ" },
  { main: "*", sub: "" },
  { main: "0", sub: "+" },
  { main: "#", sub: "" },
];

interface DialerProps {
  onKeyClick: React.Dispatch<SetStateAction<any>>;
  showInput?: boolean;
}

const Dialer: React.FC<DialerProps> = ({ onKeyClick, showInput }) => {
  const [inputValue, setInputValue] = useState("");

  const handleClick = (key: string) => {
    setInputValue((prev) => prev + key);
    onKeyClick(key);
  };

  return (
    <div className="dialer-container">
      {showInput && (
        <Input
          className="input-number"
          value={inputValue}
          // onChange={(e) => setInputValue(e.target.value)}
        />
      )}
      <div className="dialer">
        {dialerKeys.map((key, index) => (
          <Button
            key={index}
            shape="circle"
            className="dialer-btn"
            onClick={() => handleClick(key.main)}
          >
            <div className="dialer-text">
              <span className="main">{key.main}</span>
              {key.sub && <span className="sub">{key.sub}</span>}
            </div>
          </Button>
        ))}
      </div>
    </div>
  );
};

export default Dialer;
